import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import TourStyledProductTypeInfoModal, { TourStyledProductTypeInfoModalResult } from 'components/Tours/TourStyledProductTypeInfoModal'
import { TOUR_STYLED_PRODUCT_TYPE_TITLES } from 'constants/tours'
import ModalContext from 'contexts/ModalContext'
import { isTourProductTypeStyled } from 'lib/tours/tourUtils'
import React, { MouseEventHandler, useCallback, useContext } from 'react'

interface Props {
  productType: App.Tours.V2ProductTypeStyled
  onCheckAvailability: () => void
}

function TourStyleTag({ productType, onCheckAvailability }: Props) {
  const showModal = useContext(ModalContext)
  const openTourStyleInfoModal = useCallback<MouseEventHandler<HTMLButtonElement>>(async(event) => {
    event.preventDefault()
    const result = await showModal<TourStyledProductTypeInfoModalResult>(<TourStyledProductTypeInfoModal
      primaryActionText="Check availability"
      productType={productType}
    />)
    if (result === 'primary-action') {
      onCheckAvailability()
    }
  }, [onCheckAvailability, showModal, productType])

  if (!isTourProductTypeStyled(productType)) return null

  return <BodyTextBlock
    variant="large"
    endIcon={productType !== 'custom_tour' && <Clickable onClick={openTourStyleInfoModal}><LineInfoCircleIcon /></Clickable>}
  >
    Tour style: {TOUR_STYLED_PRODUCT_TYPE_TITLES[productType]}
  </BodyTextBlock>
}

export default TourStyleTag
